var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightConfetti({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.3967 122.574L89.9911 128.408L99.6685 132.9L110.485 137.919L118.292 141.54L126.506 145.346L132.386 148.069L138.517 150.912L143.24 153.107L148.685 155.635L152.38 157.349L157.769 159.849C159.094 160.46 160.464 159.09 159.844 157.775L157.334 152.394L155.621 148.708L153.074 143.272L150.88 138.568L148.027 132.446L145.295 126.593L141.471 118.407L137.841 110.628L132.803 99.8479L128.321 90.2259L122.264 77.2422L77.406 122.546L77.3967 122.574Z",
    fill: "url(#paint0_linear_29716_8725)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.686 155.646L152.381 157.359C153.27 156.646 154.15 155.859 155.002 155.007C155.854 154.155 156.632 153.294 157.336 152.405L155.622 148.719C154.696 149.978 153.622 151.228 152.427 152.423C151.233 153.618 149.964 154.701 148.686 155.637V155.646Z",
    fill: "url(#paint1_linear_29716_8725)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.507 150.921L143.23 153.116C145.054 151.838 146.86 150.329 148.592 148.597C150.305 146.884 151.805 145.087 153.074 143.29L150.879 138.586C149.425 140.901 147.564 143.216 145.388 145.402C143.184 147.606 140.85 149.467 138.507 150.931V150.921Z",
    fill: "url(#paint2_linear_29716_8725)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.503 145.357L132.384 148.08C135.329 146.274 138.311 143.931 141.117 141.125C143.923 138.319 146.219 135.393 148.025 132.466L145.293 126.613C143.367 130.188 140.654 133.865 137.255 137.263C133.819 140.699 130.115 143.431 126.503 145.357Z",
    fill: "url(#paint3_linear_29716_8725)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9886 128.408L99.666 132.899C106.084 129.899 112.807 125.166 118.984 118.989C125.105 112.868 129.791 106.219 132.8 99.8564L128.318 90.2344C125.522 97.6245 120.262 105.672 112.964 112.97C105.602 120.332 97.4434 125.639 89.9886 128.398V128.408Z",
    fill: "url(#paint4_linear_29716_8725)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.482 137.927L118.289 141.548C122.725 139.075 127.244 135.667 131.448 131.454C135.653 127.24 138.996 122.813 141.468 118.424L137.838 110.645C135.319 115.886 131.439 121.35 126.392 126.397C121.308 131.481 115.77 135.399 110.482 137.918V137.927Z",
    fill: "url(#paint5_linear_29716_8725)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M96.4614 103.316L159.869 159.02C159.711 159.4 159.424 159.696 159.054 159.863L82.1538 117.763L96.4614 103.316Z",
    fill: "url(#paint6_linear_29716_8725)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6942 121.869C80.2503 125.425 93.2429 118.193 105.717 105.718C118.191 93.2439 125.423 80.2509 121.867 76.6947C118.311 73.1386 105.319 80.3713 92.8447 92.8457C80.3707 105.32 73.1381 118.313 76.6942 121.869Z",
    fill: "url(#paint7_linear_29716_8725)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1289 106.758C32.514 106.645 32.855 106.382 33.3412 105.547C33.6632 105.81 33.8715 106.131 34.0231 106.633C33.5748 107.204 33.2591 107.505 32.6277 107.825C32.5835 107.398 32.4446 107.166 32.1352 106.758H32.1289Z",
    fill: "url(#paint8_linear_29716_8725)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2086 105.196C17.8361 105.529 17.5898 105.911 17.5456 106.589C15.9798 106.018 15.0579 105.466 13.7509 104.562C13.9404 103.614 14.2687 103.15 14.5339 102.836C15.683 104.085 16.6554 104.587 18.2086 105.196Z",
    fill: "url(#paint9_linear_29716_8725)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0911 91.0765C66.2236 91.2711 66.2173 91.4594 66.1984 91.767C65.5291 91.6979 64.7967 91.8234 63.9632 92.0431C63.9632 91.7983 63.9127 91.6414 63.7675 91.4155C64.6325 91.1268 65.144 91.0452 66.0911 91.0828V91.0765Z",
    fill: "url(#paint10_linear_29716_8725)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9686 116.119C35.6718 115.642 35.3751 115.416 34.7058 115.341C35.1162 114.726 35.5266 114.419 36.3158 113.91C36.8399 113.985 37.0672 114.186 37.3766 114.688C36.7073 115.134 36.2527 115.498 35.9686 116.119Z",
    fill: "url(#paint11_linear_29716_8725)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8438 67.2089C22.3868 66.9579 22.652 66.7947 22.9487 66.3867C23.1066 66.5625 23.2265 66.6503 23.3844 66.6629C23.094 67.1273 22.7909 67.3658 22.2353 67.6859C22.0522 67.5604 21.9322 67.4035 21.8438 67.2089Z",
    fill: "url(#paint12_linear_29716_8725)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3663 74.1012C41.326 73.8564 41.8627 73.6304 42.6962 73.0781C42.974 73.4798 43.1445 73.8689 43.1381 74.3271C42.6141 74.7539 41.869 75.1305 40.8209 75.5322C40.8967 74.823 40.8209 74.4464 40.3726 74.1075L40.3663 74.1012Z",
    fill: "url(#paint13_linear_29716_8725)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7726 30.2769C48.1223 30.6409 47.4846 30.5844 46.5122 30.2455C46.8721 28.6701 46.9037 27.7035 46.6322 26.1909C47.352 26.398 47.9076 26.3102 48.9557 25.9336C49.2146 27.4776 49.1136 28.7015 48.7663 30.2831L48.7726 30.2769Z",
    fill: "url(#paint14_linear_29716_8725)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8137 66.2529C13.6495 65.6127 13.6306 65.2486 13.9589 64.621C15.0639 64.6022 15.7142 64.508 16.7687 64.2695C16.7181 64.6587 16.7687 64.9411 16.8571 65.1733C15.6385 65.4118 14.9187 65.7131 13.8137 66.2529Z",
    fill: "url(#paint15_linear_29716_8725)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.716 14.9492C126.366 15.1061 126.701 15.2693 127.105 15.853C126.6 16.8384 126.366 17.4598 126.082 18.5017C125.754 18.2694 125.482 18.1816 125.236 18.1502C125.602 16.9639 125.678 16.1857 125.716 14.9492Z",
    fill: "url(#paint16_linear_29716_8725)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.646 58.043C102.372 59.769 102.631 60.9176 102.757 62.4804C101.501 62.4992 100.712 62.2921 100.017 61.9218C100.162 60.9615 99.8909 60.2523 99.3795 59.1915C100.459 59.0974 100.983 58.7773 101.64 58.043H101.646Z",
    fill: "url(#paint17_linear_29716_8725)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M135.371 62.3544C135.479 63.8921 135.409 65.1349 134.841 66.2834C133.818 66.4152 133.155 66.2897 132.448 65.9194C133.023 64.4696 133.13 63.572 132.934 62.0469C133.875 62.549 134.5 62.6996 135.365 62.3544H135.371Z",
    fill: "url(#paint18_linear_29716_8725)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4223 69.1676C77.2392 68.9856 77.0372 68.8726 76.7468 68.7533C77.2329 68.314 77.5297 68.0002 77.8012 67.5859C78.1421 67.6236 78.3 67.7303 78.4957 67.9123C78.3126 68.2261 77.9212 68.6906 77.4223 69.1676Z",
    fill: "url(#paint19_linear_29716_8725)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3107 39.3266C32.0494 40.0547 33.0912 40.4814 35.6168 40.5254C35.4211 41.5986 34.9538 42.4711 33.9941 43.4376C32.1189 43.1426 31.0265 42.8163 29.4986 41.7869C30.4204 41.1467 30.774 40.5442 31.3044 39.3203L31.3107 39.3266Z",
    fill: "url(#paint20_linear_29716_8725)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.568 120.751C49.126 120.927 48.905 121.04 48.6525 121.353C48.5388 121.203 48.4441 121.127 48.3178 121.115C48.5704 120.757 48.8229 120.581 49.2776 120.355C49.4165 120.468 49.5049 120.594 49.568 120.751Z",
    fill: "url(#paint21_linear_29716_8725)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M110.118 79.671C110.245 80.1668 110.093 80.5748 109.695 81.1585C108.704 80.6375 108.066 80.443 107.006 80.3551C107.277 79.9157 107.315 79.5329 107.245 78.7734C108.325 78.8801 109.121 79.1688 110.118 79.6772V79.671Z",
    fill: "url(#paint22_linear_29716_8725)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3024 90.5863C81.1785 90.5925 80.566 90.4733 79.6568 89.6825C80.0672 87.8686 80.1872 86.7639 80.2188 84.9375C80.8438 85.1823 81.3363 85.2137 81.7467 85.1635C81.6457 87.2535 81.8478 88.5464 82.2961 90.58L82.3024 90.5863Z",
    fill: "url(#paint23_linear_29716_8725)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5465 12.4027C53.4226 12.4089 52.8102 12.2897 51.9009 11.4989C52.3114 9.68498 52.4313 8.58034 52.4629 6.75391C53.088 6.99869 53.5805 7.03007 53.9909 6.97986C53.8898 9.0699 54.0919 10.3628 54.5402 12.3964L54.5465 12.4027Z",
    fill: "url(#paint24_linear_29716_8725)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6725 82.3723C38.5312 81.3994 39.1057 80.9726 40.4885 80.7969C41.745 82.548 42.6163 83.4957 44.1696 84.9267C43.475 85.2782 43.0709 85.6674 42.7994 86.0628C41.0694 84.3681 39.7876 83.5522 37.6725 82.3723Z",
    fill: "url(#paint25_linear_29716_8725)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8858 48.9883C89.7445 49.1452 90.6664 49.3962 91.3672 50.118C91.4051 50.8461 91.4745 51.3357 91.7145 52.0512C91.121 51.7876 90.6916 51.9194 89.9339 52.4403C89.8518 51.3357 89.4478 50.3377 88.8795 48.9883H88.8858Z",
    fill: "url(#paint26_linear_29716_8725)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0133 97.0479C54.7923 97.481 54.4514 97.6567 53.8831 97.9266C53.3401 96.6713 52.393 95.5039 51.1618 94.2486C51.6101 94.0101 51.8247 93.7591 52.0962 93.2695C53.4727 94.5185 54.1357 95.3345 55.0133 97.0479Z",
    fill: "url(#paint27_linear_29716_8725)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74333 74.847C1.49077 75.0667 1.22558 75.0918 0.789913 75.1169C0.770971 74.1692 0.461585 73.1712 0.000662923 72.0415C0.347933 72.0038 0.556286 71.8971 0.859358 71.6523C1.4213 72.8135 1.62967 73.5102 1.74963 74.8408L1.74333 74.847Z",
    fill: "url(#paint28_linear_29716_8725)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9215 89.6966C30.7447 89.2447 30.4669 88.8995 29.8608 88.6359C30.9026 87.3995 31.7234 86.7467 32.9862 85.8555C33.7944 86.345 34.1164 86.7969 34.3121 87.1421C32.7778 87.7698 31.9949 88.4916 30.9215 89.6966Z",
    fill: "url(#paint29_linear_29716_8725)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5504 76.4082C94.4746 76.8601 94.2915 77.1111 93.8496 77.3497C93.4013 77.1676 93.1045 76.9731 92.9151 76.6592C93.1424 76.2011 93.1613 75.8308 93.1361 75.2031C93.6033 75.7366 93.9064 76.0567 94.5504 76.4082Z",
    fill: "url(#paint30_linear_29716_8725)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3496 91.5479C99.5327 90.9516 99.8295 90.6378 100.467 90.3867C101.042 90.7131 101.414 91.0269 101.623 91.4851C101.231 92.0751 101.143 92.5709 101.067 93.437C100.524 92.6274 100.164 92.1441 99.3496 91.5479Z",
    fill: "url(#paint31_linear_29716_8725)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0905 76.6108C75.8569 76.0397 75.7685 75.6631 75.7306 75.1484C76.141 75.1484 76.3999 75.2112 76.6335 75.3367C76.583 75.6505 76.6714 75.889 76.8356 76.2343C76.482 76.2656 76.3052 76.3661 76.0905 76.6108Z",
    fill: "url(#paint32_linear_29716_8725)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M102.923 14.7605C102.399 13.4864 102.209 12.6454 102.121 11.4968C103.043 11.4842 103.623 11.6412 104.135 11.9173C104.028 12.6265 104.223 13.1412 104.589 13.9258C103.794 13.9948 103.409 14.227 102.923 14.7605Z",
    fill: "url(#paint33_linear_29716_8725)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5802 108.059C66.9843 108.36 67.2937 108.41 67.7672 108.416C67.4073 109.151 66.959 109.841 66.6623 110.08C66.3024 109.916 66.0372 109.703 65.7152 109.352C66.0498 109.088 66.2582 108.705 66.5739 108.059H66.5802Z",
    fill: "url(#paint34_linear_29716_8725)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9599 18.4648C71.2315 19.5569 71.3325 20.4607 71.0673 21.3583C70.3475 21.5779 69.855 21.5717 69.3057 21.3896C69.5393 20.2787 69.5077 19.6197 69.1794 18.5402C69.9181 18.7849 70.3854 18.8163 70.9663 18.4648H70.9599Z",
    fill: "url(#paint35_linear_29716_8725)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6536 86.3945C59.6599 86.9971 59.6978 87.3046 59.9567 87.7502C59.723 87.8193 59.5905 87.8946 59.521 88.0327C59.2116 87.5745 59.1169 87.1916 59.0538 86.5577C59.2495 86.4447 59.4452 86.4008 59.6599 86.3945H59.6536Z",
    fill: "url(#paint36_linear_29716_8725)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0486 47.7706C47.7077 47.6513 47.3793 47.6325 46.9311 47.8396C46.7416 46.6597 46.7732 45.8814 46.8932 44.7454C47.5625 44.532 47.9729 44.5759 48.2633 44.6324C47.8718 45.7935 47.8908 46.5781 48.0486 47.7643V47.7706Z",
    fill: "url(#paint37_linear_29716_8725)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0792 28.7188C96.4517 28.8317 96.8495 28.9886 97.121 29.3464C97.1021 29.6728 97.1021 29.8924 97.1715 30.2188C96.9253 30.0682 96.7295 30.1058 96.3633 30.3004C96.3886 29.8046 96.256 29.3464 96.0792 28.7188Z",
    fill: "url(#paint38_linear_29716_8725)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4798 0.169463C93.2185 0.533494 94.1151 0.596258 96.0346 0C96.1545 0.859867 96.0346 1.63186 95.5484 2.60471C94.0583 2.85576 93.1554 2.88087 91.7411 2.48545C92.2714 1.76994 92.3914 1.23017 92.4798 0.175739V0.169463Z",
    fill: "url(#paint39_linear_29716_8725)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M117.898 62.4062C117.873 61.9292 117.835 61.6907 117.614 61.3518C117.791 61.289 117.898 61.2263 117.949 61.1133C118.209 61.4648 118.297 61.7597 118.367 62.2619C118.215 62.356 118.063 62.3999 117.898 62.4062Z",
    fill: "url(#paint40_linear_29716_8725)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M112.615 52.5554C112.318 52.6119 112.103 52.5114 111.756 52.3294C112.179 51.5888 112.4 50.6787 112.564 49.6055C112.848 49.7373 113.057 49.7498 113.404 49.6933C113.303 50.8419 113.145 51.4758 112.621 52.5554H112.615Z",
    fill: "url(#paint41_linear_29716_8725)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M127.074 74.5549C126.815 74.8373 126.512 75.1135 126.083 75.2076C125.805 75.057 125.603 74.9628 125.281 74.8875C125.514 74.7306 125.565 74.5423 125.546 74.1406C125.975 74.3666 126.442 74.4482 127.074 74.5486V74.5549Z",
    fill: "url(#paint42_linear_29716_8725)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1135 35.5424C82.9974 35.26 83.5152 35.2097 84.4244 35.6114C84.5443 37.1429 84.7211 38.0467 85.1442 39.4965C84.5885 39.4589 84.1908 39.5467 83.8814 39.6911C83.452 38.0153 82.9722 37.0424 82.1135 35.5424Z",
    fill: "url(#paint43_linear_29716_8725)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M112.58 67.2578C113.275 67.967 113.755 68.6072 113.957 69.4106C113.508 69.8939 113.13 70.1073 112.631 70.214C112.309 69.2663 111.993 68.7767 111.261 68.1051C111.93 67.967 112.302 67.785 112.587 67.2578H112.58Z",
    fill: "url(#paint44_linear_29716_8725)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6803 78.7864C63.7332 78.2153 63.2597 77.7194 62.6977 76.6022C63.9858 76.0939 64.6424 75.5604 65.2044 74.7695C66.1325 75.2403 66.6819 75.711 67.4332 76.5395C66.322 77.1295 65.64 77.7383 64.6866 78.7864H64.6803Z",
    fill: "url(#paint45_linear_29716_8725)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1886 91.7171C91.5383 91.328 91.1784 91.0141 90.7617 90.5371C91.1658 90.2296 91.4752 90.1103 91.7909 90.0664C91.974 90.4116 92.2328 90.5811 92.6559 90.807C92.3276 91.0957 92.2328 91.3217 92.195 91.7171H92.1886Z",
    fill: "url(#paint46_linear_29716_8725)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M123.745 104.884C123.436 104.985 123.234 104.991 122.874 104.897C123.013 104.514 123.019 104.263 122.95 103.987C123.234 103.874 123.449 103.842 123.777 103.836C123.695 104.194 123.695 104.464 123.745 104.878V104.884Z",
    fill: "url(#paint47_linear_29716_8725)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9156 51.6127C75.6126 52.4286 75.682 52.9747 75.9156 53.7655C74.5076 53.527 73.1186 53.1316 72.5692 52.7613C72.6576 52.0834 72.8912 51.5374 73.3143 50.8281C73.9331 51.2549 74.6655 51.4056 75.9156 51.6064V51.6127Z",
    fill: "url(#paint48_linear_29716_8725)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M103.896 43.9299C104.06 44.8463 103.883 45.4614 103.195 46.2208C102.21 46.1769 101.503 46.0074 100.915 45.5304C101.035 44.4885 100.821 43.7667 100.335 42.5742C101.604 43.2835 102.412 43.6851 103.896 43.9299Z",
    fill: "url(#paint49_linear_29716_8725)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M129.448 49.5456C129.53 48.0079 129.473 47.2171 128.892 46.0434C129.492 45.9053 129.839 45.7296 130.048 45.3906C130.761 46.6145 130.944 47.5874 131.007 49.2255C130.49 49.4828 129.991 49.5644 129.442 49.5393L129.448 49.5456Z",
    fill: "url(#paint50_linear_29716_8725)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8649 3.11356C79.5807 3.38345 79.4039 3.69727 79.3913 4.22448C78.1411 3.82907 77.4024 3.42111 76.348 2.75581C76.4679 2.00892 76.7079 1.62606 76.9036 1.375C77.8444 2.31646 78.6273 2.68049 79.8649 3.10729V3.11356Z",
    fill: "url(#paint51_linear_29716_8725)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1989 104.427C82.6811 105.105 82.4412 105.99 82.6748 108.042C81.7782 107.998 81.0079 107.716 80.1176 107.044C80.1555 105.494 80.307 104.578 80.989 103.234C81.614 103.912 82.1444 104.138 83.1989 104.433V104.427Z",
    fill: "url(#paint52_linear_29716_8725)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5671 86.4595C69.4471 85.8445 69.4534 85.4993 69.7944 84.9218C70.8425 84.9658 71.4676 84.9156 72.4778 84.7461C72.4084 85.1164 72.4399 85.3863 72.5094 85.606C71.3413 85.7629 70.6468 86.0076 69.5671 86.4595Z",
    fill: "url(#paint53_linear_29716_8725)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M58.188 67.1079C58.3774 66.6811 58.5605 66.4551 59.0025 66.1602C59.2867 66.6748 59.5518 66.9196 59.9117 67.1079C59.7602 67.5221 59.5897 67.7732 59.2803 68.1372C58.971 67.7041 58.6742 67.4531 58.1817 67.1079H58.188Z",
    fill: "url(#paint54_linear_29716_8725)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6715 99.2227C38.2145 99.6432 38.4608 99.9382 38.5934 100.66C37.6968 101.375 37.2169 101.859 36.4971 102.725C36.2888 102.367 36.0678 102.166 35.8468 102.034C36.6992 101.068 37.097 100.371 37.6652 99.2227H37.6715Z",
    fill: "url(#paint55_linear_29716_8725)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5947 75.787C26.2159 75.1782 25.856 74.4878 25.9128 73.6593C26.3358 73.2325 26.601 72.9187 26.8978 72.3789C27.0619 72.881 27.3839 73.0693 28.1227 73.2388C27.4913 73.8978 27.1061 74.6949 26.5947 75.7807V75.787Z",
    fill: "url(#paint56_linear_29716_8725)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M60.189 41.0028C61.1234 40.438 61.698 40.2371 62.8472 40.4505C63.4091 42.1702 63.8637 43.1494 64.7477 44.6871C64.1037 44.7938 63.6806 45.0072 63.3586 45.252C62.3989 43.4569 61.5844 42.4778 60.189 40.9966V41.0028Z",
    fill: "url(#paint57_linear_29716_8725)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1949 29.2489C65.4499 29.4623 64.6164 29.6192 63.7704 29.3179C63.4547 28.753 63.2021 28.389 62.7286 27.9183C63.3031 27.8995 63.5936 27.6233 63.9977 26.9141C64.4965 27.7614 65.2163 28.4016 66.1949 29.2489Z",
    fill: "url(#paint58_linear_29716_8725)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9224 78.5152C97.6699 77.8248 97.5878 77.3729 97.5689 76.7578C98.0614 76.7704 98.3644 76.8708 98.6296 77.0277C98.5538 77.4043 98.6486 77.6804 98.8317 78.1072C98.4086 78.1261 98.1939 78.239 97.9224 78.5152Z",
    fill: "url(#paint59_linear_29716_8725)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2936 97.8555C44.5816 98.0877 45.352 98.3701 46.318 98.8848C45.8571 99.6191 45.434 99.9957 44.9542 100.266C44.4427 99.82 43.925 99.707 43.1105 99.6066C43.4578 98.9476 43.4704 98.5208 43.2873 97.8617L43.2936 97.8555Z",
    fill: "url(#paint60_linear_29716_8725)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M124.839 25.5535C125.218 25.3589 125.502 25.089 125.679 24.543C126.854 25.3401 127.498 25.9928 128.394 27.0096C128.034 27.7502 127.668 28.0703 127.384 28.2712C126.696 26.997 125.995 26.382 124.846 25.5535H124.839Z",
    fill: "url(#paint61_linear_29716_8725)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3387 65.1484C90.5471 65.456 90.5787 65.707 90.4524 66.0962C90.0862 66.2405 89.802 66.2907 89.5116 66.2091C89.3853 65.8075 89.1896 65.5815 88.8171 65.2238C89.3979 65.2802 89.7578 65.2991 90.3387 65.1484Z",
    fill: "url(#paint62_linear_29716_8725)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M131.663 77.8008C131.505 78.4347 131.278 79.1126 130.697 79.6021C130.148 79.6021 129.775 79.6272 129.226 79.7778C129.453 79.3511 129.371 79.0247 129.018 78.4347C129.857 78.4221 130.628 78.1648 131.67 77.8071L131.663 77.8008Z",
    fill: "url(#paint63_linear_29716_8725)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5641 65.7366C60.5641 66.2325 60.4757 66.5274 60.1726 66.9982C59.6801 66.6216 59.3202 66.4961 58.8846 66.4647C58.853 66.0002 58.9098 65.6864 59.055 65.2031C59.5412 65.4918 59.9327 65.6111 60.5578 65.7366H60.5641Z",
    fill: "url(#paint64_linear_29716_8725)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6337 96.8079L47.4648 97.605C47.4648 97.605 49.561 94.7681 51.752 94.5861C52.1119 94.5547 52.4718 94.5986 52.8317 94.7304L51.0006 93.9333C48.4687 92.9668 45.6337 96.8079 45.6337 96.8079Z",
    fill: "url(#paint65_linear_29716_8725)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5115 114.425C77.802 114.538 78.1177 114.6 78.4586 114.625C76.1856 112.335 75.8572 105.368 71.1849 103.146C71.1217 103.114 71.0586 103.083 70.9892 103.058C70.945 103.039 70.9008 103.02 70.8566 103.001C70.6419 102.92 70.4209 102.863 70.1999 102.832C74.4745 105.719 74.5502 113.006 77.341 114.355C77.3979 114.381 77.4484 114.406 77.5052 114.431L77.5115 114.425Z",
    fill: "url(#paint66_linear_29716_8725)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5565 106.437C56.9101 106.588 57.2637 106.682 57.611 106.714C54.9401 104.184 55.1548 95.8555 52.926 94.7822C52.926 94.7822 52.8692 94.7571 52.8376 94.7446C52.484 94.6065 52.1178 94.5688 51.7579 94.6002C53.469 97.0731 53.4122 105.069 56.5565 106.444V106.437Z",
    fill: "url(#paint67_linear_29716_8725)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M77.514 114.426L79.3387 115.223C82.4073 116.441 88.8097 112.004 92.0172 113.334L90.1862 112.537C87.2754 111.332 81.757 114.853 78.4611 114.627C78.1201 114.602 77.7981 114.539 77.514 114.426Z",
    fill: "url(#paint68_linear_29716_8725)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5578 106.435L58.3889 107.232C62.3982 108.983 66.4329 102.292 70.2024 102.832C70.4233 102.864 70.638 102.92 70.859 103.002L69.028 102.205C65.4037 100.818 61.508 107.088 57.6185 106.711C57.265 106.68 56.9114 106.592 56.5641 106.435H56.5578Z",
    fill: "url(#paint69_linear_29716_8725)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2813 34.6626C90.5757 36.9347 96.5298 36.0685 98.525 38.1209L97.8999 36.7213C96.0626 34.8258 90.8409 35.4158 89.0288 33.7274C88.8962 33.6082 88.7888 33.4764 88.6941 33.332L89.1235 34.3111L89.2813 34.6626Z",
    fill: "url(#paint70_linear_29716_8725)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3797 29.3636C90.5983 29.4075 92.0126 29.0874 93.2312 28.3782C93.8247 28.033 94.0331 27.7568 93.9826 27.5685C93.8121 26.966 90.9392 27.3049 89.3797 29.3636Z",
    fill: "url(#paint71_linear_29716_8725)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8447 24.6266C88.9243 24.5576 90.0293 24.2626 90.8691 23.7354C91.2605 23.4906 91.3931 23.3148 91.3489 23.2144C91.2037 22.9006 89.259 23.3399 87.8447 24.6266Z",
    fill: "url(#paint72_linear_29716_8725)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5853 27.9639L86.6169 28.0393C86.6674 28.1522 86.7368 28.2527 86.8126 28.3468C86.8884 28.4472 86.9768 28.5351 87.0778 28.623C87.0778 28.3907 87.1283 28.1334 87.223 27.8635C87.4756 27.1292 87.9302 26.5204 88.4606 26.0308C87.8923 26.0685 87.3241 26.0371 86.8126 25.9492C86.7305 26.1124 86.6548 26.2819 86.5916 26.4639C86.4653 26.8405 86.4211 27.1794 86.4527 27.4869C86.4717 27.6627 86.5159 27.8196 86.579 27.9702L86.5853 27.9639Z",
    fill: "url(#paint73_linear_29716_8725)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0602 23.2893C84.1675 23.5403 84.3506 23.7474 84.5906 23.9295C84.6474 23.5403 84.8621 23.0947 85.2535 22.5989L84.6285 21.1992C83.9465 22.0528 83.8203 22.7495 84.0539 23.2893H84.0602Z",
    fill: "url(#paint74_linear_29716_8725)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6946 33.3328C88.7893 33.4771 88.8966 33.6089 89.0292 33.7282C89.0292 33.6529 89.0292 33.5775 89.0292 33.4959C89.0924 32.3662 89.4712 31.4624 90.0016 30.7594C89.5407 30.7406 89.105 30.6778 88.7198 30.5586C88.5494 31.0168 88.4357 31.5252 88.4041 32.0963C88.3915 32.3662 88.4105 32.611 88.4736 32.8307C88.5241 33.0127 88.5999 33.1821 88.6946 33.3328Z",
    fill: "url(#paint75_linear_29716_8725)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0625 23.2964L84.6876 24.6961C84.978 25.3488 85.7988 25.7693 86.8217 25.9451C87.3331 26.0329 87.9014 26.0643 88.4697 26.0267C89.5493 25.9576 90.6543 25.6626 91.4941 25.1354C91.8855 24.8906 92.0181 24.7149 91.9739 24.6145L91.3488 23.2148C91.393 23.3153 91.2604 23.491 90.869 23.7358C90.0292 24.2693 88.9243 24.5643 87.8446 24.627C86.5628 24.7086 85.319 24.4701 84.5929 23.9304C84.3529 23.7546 84.1698 23.5412 84.0625 23.2964Z",
    fill: "url(#paint76_linear_29716_8725)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6204 28.0395L87.2518 29.458C87.5107 29.9789 88.041 30.3492 88.7229 30.5563C89.1081 30.6756 89.5438 30.7446 90.0047 30.7572C91.2233 30.8011 92.6376 30.481 93.8562 29.7718C94.4497 29.4266 94.6581 29.1504 94.6076 28.9621L93.9825 27.5625C94.033 27.7508 93.8247 28.027 93.2311 28.3722C92.0188 29.0751 90.6045 29.4015 89.3796 29.3576C88.4388 29.3262 87.6117 29.0751 87.075 28.6169C86.974 28.5353 86.8856 28.4412 86.8098 28.3408C86.734 28.2466 86.6709 28.1399 86.6141 28.0332L86.6204 28.0395Z",
    fill: "url(#paint77_linear_29716_8725)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7814 95.2551C22.3575 95.776 25.6155 90.7486 28.4821 90.6042L27.0109 90.1523C24.3653 90.2841 21.3788 94.5835 18.91 94.8283C18.7332 94.8471 18.5628 94.8408 18.3923 94.8157L19.4152 95.1358L19.7877 95.2551H19.7814Z",
    fill: "url(#paint78_linear_29716_8725)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M15.828 91.6912C16.6615 90.8062 17.3497 89.5321 17.6149 88.1638C17.7411 87.4923 17.6717 87.1533 17.4949 87.0718C16.9266 86.8019 15.2976 89.1806 15.828 91.6975V91.6912Z",
    fill: "url(#paint79_linear_29716_8725)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2256 89.7323C11.8823 88.8788 12.3874 87.8557 12.5326 86.8829C12.602 86.431 12.5579 86.2176 12.4505 86.1799C12.1159 86.0795 11.1688 87.8306 11.2193 89.7323H11.2256Z",
    fill: "url(#paint80_linear_29716_8725)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9308 92.8636L13.0129 92.8887C13.1328 92.9201 13.2528 92.9389 13.3727 92.9452C13.499 92.9515 13.6253 92.9452 13.7516 92.9264C13.5748 92.7695 13.4169 92.5623 13.2717 92.3176C12.8803 91.646 12.7161 90.9054 12.6972 90.1836C12.3499 90.6355 11.9584 91.0372 11.5543 91.3636C11.6238 91.533 11.7059 91.7025 11.8006 91.8657C12.0026 92.2109 12.2299 92.4619 12.4825 92.6377C12.6277 92.7381 12.7729 92.8134 12.9308 92.8636Z",
    fill: "url(#paint81_linear_29716_8725)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72868 91.6919H7.735C7.99388 91.7735 8.27169 91.7735 8.56213 91.7108C8.30326 91.4095 8.10753 90.9639 7.99388 90.3425L6.52271 89.8906C6.71845 90.9639 7.16674 91.5162 7.72868 91.6919Z",
    fill: "url(#paint82_linear_29716_8725)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3881 94.8144C18.5586 94.8395 18.7354 94.8458 18.9059 94.8269C18.8491 94.7767 18.7922 94.7265 18.7354 94.67C17.9209 93.8792 17.4852 93.0005 17.3021 92.1406C16.9864 92.4796 16.6455 92.7557 16.3045 92.9691C16.5381 93.3959 16.8538 93.8164 17.2642 94.2181C17.46 94.4064 17.662 94.5508 17.8641 94.6449C18.0345 94.7265 18.2113 94.783 18.3881 94.8081V94.8144Z",
    fill: "url(#paint83_linear_29716_8725)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7335 91.6904L9.20466 92.1423C9.88658 92.3557 10.7516 92.0167 11.5535 91.364C11.9576 91.0376 12.349 90.6359 12.6963 90.184C13.353 89.3304 13.8581 88.3074 14.0033 87.3345C14.0728 86.8826 14.0286 86.663 13.9212 86.6316L12.4501 86.1797C12.5574 86.2111 12.6016 86.4307 12.5321 86.8826C12.3806 87.8618 11.8818 88.8785 11.2251 89.7321C10.4422 90.7426 9.44459 91.5209 8.56063 91.7092C8.27019 91.772 7.98606 91.772 7.7335 91.6904Z",
    fill: "url(#paint84_linear_29716_8725)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0111 92.8885L14.5075 93.3467C15.0757 93.4911 15.7008 93.3404 16.307 92.9701C16.6542 92.7567 16.9889 92.4806 17.3046 92.1416C18.138 91.2567 18.8262 89.9826 19.0914 88.6143C19.2177 87.9427 19.1483 87.6038 18.9715 87.5222L17.5003 87.0703C17.6771 87.1519 17.7466 87.4908 17.6203 88.1624C17.3551 89.5369 16.6732 90.8048 15.8334 91.6897C15.1894 92.3739 14.457 92.8321 13.7624 92.9325C13.6361 92.9513 13.5099 92.9576 13.3836 92.9513C13.2636 92.9513 13.1373 92.9262 13.0237 92.8948L13.0111 92.8885Z",
    fill: "url(#paint85_linear_29716_8725)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2142 79.7699L29.5543 80.7678C29.0681 80.5921 28.6262 80.3473 28.2284 80.0335C25.425 77.8744 24.3832 72.8093 21.6934 70.4745L18.3533 69.4766C21.4282 72.144 22.3501 78.389 26.2142 79.7699Z",
    fill: "url(#paint86_linear_29716_8725)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0085 80.8982C30.28 80.9673 30.5641 81.0112 30.8672 81.0238C33.4622 81.1807 37.0865 79.4609 39.5363 78.7015C42.144 77.8918 44.7517 77.4462 47.4162 77.6157C47.9466 77.6471 48.4706 77.7098 48.9821 77.7977C48.4517 77.5655 47.9087 77.3646 47.3467 77.1952H47.3215C46.286 76.8813 45.2 76.6868 44.0698 76.6177C41.4053 76.4483 38.7976 76.8939 36.1899 77.7036C33.9484 78.4002 30.7346 79.8877 28.2216 80.0258C28.6257 80.3396 29.0614 80.5844 29.5476 80.7602C29.6928 80.8104 29.8443 80.8606 30.0022 80.8982H30.0085Z",
    fill: "url(#paint87_linear_29716_8725)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6661 95.1233C71.9479 95.4623 73.2422 95.4748 74.5114 95.0292L71.1713 94.0312C70.3504 94.32 69.5233 94.4141 68.6898 94.3514C69.1697 94.5961 69.6496 94.797 70.1421 94.9602C70.3189 95.0166 70.4893 95.0731 70.6661 95.1171V95.1233Z",
    fill: "url(#paint88_linear_29716_8725)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0425 94.0412H67.0551L70.1364 94.9575C69.6502 94.7943 69.164 94.5872 68.6841 94.3487C64.4348 92.1959 60.5959 87.1309 58.7396 84.3065C56.7696 81.3126 53.9851 79.1787 50.6892 78.1933L47.3491 77.1953C47.9111 77.3648 48.4541 77.5656 48.9845 77.7978C51.5669 78.9339 53.7641 80.8231 55.3995 83.3085C57.502 86.5032 62.1428 92.5725 67.0425 94.0349V94.0412Z",
    fill: "url(#paint89_linear_29716_8725)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1823 46.5614L57.7798 48.1493C57.5967 47.9359 57.4515 47.7162 57.3315 47.4777C56.3718 45.5948 57.2747 42.9775 58.5817 40.4419L56.9779 38.8477C55.5067 41.6971 54.547 44.6533 56.176 46.5551L56.1823 46.5614Z",
    fill: "url(#paint90_linear_29716_8725)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0934 57.3294C72.0239 57.0658 71.9103 56.8398 71.7335 56.6264C71.4936 56.3377 71.1463 56.0804 70.6412 55.8042C69.1953 55.0636 67.44 55.3272 66.1645 54.9883C66.2719 55.39 66.4297 55.6912 66.6381 55.9297C67.7494 57.2039 70.1613 56.4381 72.0934 57.3294Z",
    fill: "url(#paint91_linear_29716_8725)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2846 49.6435C61.6231 50.0765 63.2395 50.0263 64.5465 50.428C64.5402 50.1079 64.4644 49.838 64.2371 49.5807C64.1866 49.5179 64.1235 49.4614 64.054 49.3987C63.8962 49.2669 63.6941 49.1413 63.4352 49.0095C62.0967 48.3505 60.1962 48.5388 58.6871 48.0493C58.1694 47.8923 57.7211 47.6978 57.3296 47.4844C57.4496 47.7166 57.5948 47.9426 57.7779 48.1559C58.3083 48.7773 59.1228 49.292 60.2846 49.6435Z",
    fill: "url(#paint92_linear_29716_8725)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M65.035 54.3443L66.6324 55.9322C66.4304 55.7 66.2662 55.3924 66.1589 54.9907C66.0831 54.6958 66.0326 54.3443 66.02 53.93C66.0074 52.6057 66.4557 51.7898 65.8684 51.1433L65.7295 51.0115L64.2394 49.5742C64.4667 49.8316 64.5425 50.1077 64.5488 50.4215C64.5615 50.9174 64.4099 51.5262 64.4225 52.3421C64.4478 53.3087 64.6688 53.93 65.0287 54.3443H65.035Z",
    fill: "url(#paint93_linear_29716_8725)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3451 63.4717L73.9489 65.0659C72.907 62.888 73.6268 62.4173 73.7721 60.4841C73.8415 59.1849 73.7468 58.5071 72.9828 57.8857L71.7326 56.6367C71.9094 56.8501 72.0231 57.0761 72.0925 57.3397C72.2062 57.7476 72.2125 58.2435 72.1746 58.8962C72.0231 60.8356 71.3096 61.3001 72.3514 63.478L72.3451 63.4717Z",
    fill: "url(#paint94_linear_29716_8725)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03087 46.0194L4.24709 47.1806C6.34334 45.2098 12.4237 40.6782 16.3636 41.2117C16.8056 41.2745 17.2224 41.3937 17.6012 41.5946L15.385 40.4334C11.6218 38.4564 4.36705 43.8227 2.03087 46.0131V46.0194Z",
    fill: "url(#paint95_linear_29716_8725)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7888 68.1895L50.005 69.3507C50.5543 65.6037 49.4998 63.432 47.5804 62.5094C47.2394 62.3462 46.8795 62.2207 46.4944 62.1328C47.6751 63.2939 48.2244 65.2585 47.7951 68.1895H47.7888Z",
    fill: "url(#paint96_linear_29716_8725)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0603 55.9165L19.0919 55.9354C19.4581 56.1237 19.8622 56.1864 20.2789 56.155C17.2672 52.2072 21.2576 45.3157 18.4984 42.2842C18.2269 41.9955 17.9301 41.7695 17.6018 41.5938C17.223 41.3929 16.8062 41.2674 16.3643 41.2109C19.0793 44.4182 14.7416 51.6737 18.4858 55.4772C18.6689 55.6655 18.8583 55.8098 19.054 55.9103L19.0603 55.9165Z",
    fill: "url(#paint97_linear_29716_8725)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4548 63.405C33.7768 63.5179 34.1178 63.5179 34.484 63.4552C34.4335 63.3736 34.3893 63.2794 34.3451 63.1853C33.3222 60.9948 34.2378 57.5616 33.2149 55.3712C32.855 54.5741 32.4256 54.072 31.9458 53.7958L31.8132 53.7268C31.447 53.551 31.0555 53.5008 30.6388 53.5322C30.7651 53.7268 30.885 53.9527 31.005 54.2038C32.0279 56.388 31.1123 59.8274 32.1352 62.0179C32.4004 62.5639 32.6908 62.928 33.0128 63.1602C33.1581 63.2669 33.3096 63.3422 33.4675 63.3987L33.4548 63.405Z",
    fill: "url(#paint98_linear_29716_8725)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9509 62.7411C42.984 62.0193 44.9161 61.7746 46.482 62.126C46.8671 62.2139 47.2334 62.3394 47.568 62.5026L45.8001 61.5863L45.1118 61.2285C43.426 60.5318 41.1467 60.7138 38.7284 61.5737C37.1625 62.17 35.704 63.2244 34.4728 63.4503C34.1129 63.5131 33.7656 63.5131 33.4436 63.4001L35.1989 64.3228C36.67 65.4023 38.6905 63.5884 40.9383 62.7348L40.9509 62.7411Z",
    fill: "url(#paint99_linear_29716_8725)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0923 55.9364L21.1696 57.0222L21.4095 57.1478C23.9478 58.265 27.7867 53.7899 30.628 53.5388C31.0447 53.5012 31.4362 53.5577 31.8024 53.7334L29.7251 52.6413C27.1932 51.1915 23.209 55.9553 20.273 56.1561C19.8563 56.1875 19.4522 56.1247 19.086 55.9364H19.0923Z",
    fill: "url(#paint100_linear_29716_8725)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3089 51.9414L81.9569 54.452C81.9569 54.452 85.0507 57.2199 91.4594 59.9438C91.491 59.9564 91.5226 59.9752 91.5605 59.9877C92.1477 60.2388 92.5518 60.5401 92.8043 60.8915L91.2385 58.5128C90.9985 58.1111 90.5692 57.7596 89.9062 57.4772C83.4343 54.7344 80.3089 51.9414 80.3089 51.9414Z",
    fill: "url(#paint101_linear_29716_8725)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7725 84.1719L101.357 86.5757L101.477 86.7577C102.121 87.6302 103.321 87.831 104.88 88.1072L103.233 85.5966C102.355 85.446 101.585 85.3142 100.972 85.0694C100.461 84.8686 100.057 84.5987 99.7725 84.1719Z",
    fill: "url(#paint102_linear_29716_8725)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7708 84.167C100.055 84.5875 100.459 84.8637 100.97 85.0645C100.945 84.5122 100.989 83.8532 101.116 83.0435C101.457 80.9095 102.612 79.0831 101.482 77.2881L101.406 77.1751C101.147 76.7922 100.781 76.4156 100.282 76.0391C100.465 77.4387 99.7203 78.8948 99.4614 80.533C99.1709 82.3657 99.3035 83.4703 99.7645 84.1607L99.7708 84.167Z",
    fill: "url(#paint103_linear_29716_8725)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1275 68.3047L89.706 70.7023L89.8513 70.9219C90.8615 72.2839 93.5134 73.012 96.1905 73.9974C98.0847 74.6941 99.398 75.3719 100.282 76.0498C100.781 76.4326 101.147 76.8092 101.406 77.1858L99.7453 74.6627C99.0192 73.6145 97.4912 72.5726 94.5362 71.4868C92.6547 70.7901 90.7794 70.2253 89.4851 69.4784C88.8915 69.1332 88.4117 68.7503 88.1149 68.3047H88.1275Z",
    fill: "url(#paint104_linear_29716_8725)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1174 68.2914V68.3039C88.4205 68.7558 88.9003 69.1387 89.4938 69.4776C89.9358 67.0863 94.2357 63.2514 92.8845 61.017L92.7961 60.8852C92.5435 60.54 92.1394 60.2325 91.5522 59.9814C91.5206 59.9689 91.4891 59.9563 91.4512 59.9375C91.0218 62.4794 87.2776 65.9064 87.8648 67.7704C87.9217 67.9525 88.0037 68.1282 88.1111 68.2914H88.1174Z",
    fill: "url(#paint105_linear_29716_8725)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3845 118.839L14.0466 119.015C14.0466 119.015 18.9968 117.967 26.2768 113.643C26.3147 113.624 26.3526 113.599 26.3905 113.574C27.0598 113.172 27.647 112.996 28.1774 113.002L24.7047 112.833C24.1301 112.783 23.4797 112.946 22.7284 113.398C15.3852 117.779 10.3845 118.839 10.3845 118.839Z",
    fill: "url(#paint106_linear_29716_8725)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2254 122.818L59.7423 122.981L60.0075 122.994C61.3271 122.994 62.3942 121.952 63.777 120.621L60.1149 120.445C59.3382 121.198 58.6563 121.851 57.9744 122.284C57.4125 122.642 56.8505 122.843 56.2317 122.818H56.2254Z",
    fill: "url(#paint107_linear_29716_8725)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2257 122.821C56.8445 122.846 57.4064 122.645 57.9684 122.287C57.4064 121.923 56.7814 121.402 56.0742 120.7C54.2052 118.842 53.2203 116.406 50.6378 116.231H50.4737C49.9117 116.206 49.274 116.293 48.5416 116.507C50.0569 117.329 50.9725 119.093 52.4058 120.524C54.0158 122.118 55.1965 122.777 56.2194 122.821H56.2257Z",
    fill: "url(#paint108_linear_29716_8725)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1826 122.878L35.6869 123.041L36.0089 123.054C38.0799 123.035 40.6939 120.964 43.5857 119.043C45.6314 117.688 47.2415 116.891 48.5422 116.501C49.2746 116.282 49.9123 116.2 50.4742 116.213L46.7932 116.037C45.2399 115.993 43.1121 116.746 39.9299 118.861C37.8968 120.211 35.9962 121.636 34.3357 122.37C33.5717 122.709 32.8519 122.897 32.1889 122.872L32.1826 122.878Z",
    fill: "url(#paint109_linear_29716_8725)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M32.164 122.876H32.183C32.8396 122.908 33.5594 122.713 34.3297 122.381C32.2777 120.24 31.5452 113.292 28.3756 113.016H28.1799C27.6558 113.004 27.0623 113.179 26.393 113.581C26.3551 113.606 26.3172 113.625 26.2794 113.65C28.4956 115.891 29.2091 122.004 31.4758 122.757C31.6968 122.833 31.9304 122.87 32.164 122.883V122.876Z",
    fill: "url(#paint110_linear_29716_8725)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M119.686 21.6172L119.875 23.6884C119.907 24.0713 119.837 24.4918 119.642 24.9688C118.985 26.6383 115.083 27.2095 113.264 28.7472C113.043 28.9355 112.867 29.1238 112.74 29.3121C112.5 29.6573 112.412 29.9899 112.444 30.3226L112.254 28.2451C112.21 27.7367 112.45 27.2095 113.081 26.676C114.9 25.1382 118.802 24.5734 119.458 22.8976C119.49 22.8285 119.515 22.7532 119.54 22.6842C119.673 22.295 119.717 21.9436 119.692 21.6172H119.686Z",
    fill: "url(#paint111_linear_29716_8725)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M121.82 62.7742L122.009 64.8454C121.365 64.3119 121.075 63.6717 121.012 62.9688V62.9499C120.98 62.5985 121.012 62.2281 121.075 61.8516C121.239 62.1842 121.479 62.498 121.814 62.7742H121.82Z",
    fill: "url(#paint112_linear_29716_8725)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M119.679 21.5587V21.6152C119.711 21.9416 119.667 22.2931 119.534 22.6822C118.467 20.9876 115.247 20.0712 113.953 17.8368L113.763 15.7656C115.278 18.3892 119.433 19.1925 119.686 21.5587H119.679Z",
    fill: "url(#paint113_linear_29716_8725)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M123.362 52.6914C123.362 52.955 123.344 53.25 123.287 53.5638C122.453 51.8692 119.865 51.637 118.09 50.1683C117.099 49.3147 116.613 48.4109 116.505 47.5197C116.499 47.4506 116.493 47.3879 116.487 47.3188C116.468 46.9987 116.499 46.6849 116.569 46.3711C116.821 46.9548 117.251 47.5322 117.901 48.0971C120.022 49.8545 123.318 49.8419 123.369 52.6852L123.362 52.6914Z",
    fill: "url(#paint114_linear_29716_8725)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M123.53 54.4229V54.4354C123.574 54.8057 123.555 55.2325 123.46 55.7221C123.17 57.3226 121.465 59.7327 121.08 61.8541C121.01 62.2307 120.985 62.601 121.017 62.9525L120.827 60.8813C120.632 58.5465 122.936 55.5401 123.277 53.6571C123.277 53.632 123.29 53.6006 123.29 53.5755C123.347 53.2554 123.372 52.9667 123.366 52.7031L123.536 54.4291L123.53 54.4229Z",
    fill: "url(#paint115_linear_29716_8725)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M123.501 36.9609L123.678 38.9066L123.697 39.1326C123.697 39.2016 123.697 39.2644 123.697 39.3271C123.59 41.0845 121.348 41.6871 120.073 42.4779C118.343 43.388 116.916 44.8127 116.562 46.3818C116.493 46.6956 116.461 47.0095 116.48 47.3296L116.291 45.2583C116.177 43.3252 117.812 41.4925 119.883 40.4067C120.969 39.7351 122.756 39.1953 123.331 37.9652C123.432 37.7518 123.495 37.5133 123.507 37.2559C123.507 37.1555 123.507 37.0614 123.507 36.9609H123.501Z",
    fill: "url(#paint116_linear_29716_8725)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M123.493 36.9242V36.9619C123.506 37.056 123.506 37.1565 123.499 37.2569C123.48 37.5142 123.424 37.7527 123.323 37.9661C122.603 36.7673 120.999 35.8761 119.951 35.374C117.463 34.2066 112.627 32.3738 112.437 30.3152C112.406 29.9825 112.494 29.6436 112.734 29.3047C114.054 30.9303 117.703 32.3425 119.762 33.309C121.087 33.9429 123.316 35.2108 123.493 36.9305V36.9242Z",
    fill: "url(#paint117_linear_29716_8725)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29716_8725",
    x1: 113.276,
    y1: 146.953,
    x2: 143.857,
    y2: 112.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EA3511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E11E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29716_8725",
    x1: 137.728,
    y1: 168.59,
    x2: 163.319,
    y2: 144.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FFBD6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF7F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29716_8725",
    x1: 130.949,
    y1: 161.458,
    x2: 156.547,
    y2: 137.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FFBD6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF7F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29716_8725",
    x1: 122.991,
    y1: 153.097,
    x2: 148.589,
    y2: 128.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FFBD6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF7F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_29716_8725",
    x1: 99.103,
    y1: 127.975,
    x2: 124.694,
    y2: 103.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FFBD6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF7F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_29716_8725",
    x1: 112.527,
    y1: 142.093,
    x2: 138.125,
    y2: 117.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FFBD6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF7F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_29716_8725",
    x1: 107.733,
    y1: 151.402,
    x2: 131.216,
    y2: 128.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B89D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#564931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#18140D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_29716_8725",
    x1: 92.2181,
    y1: 92.3775,
    x2: 106.723,
    y2: 106.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE3508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#AA1703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_29716_8725",
    x1: 93.2808,
    y1: 112.356,
    x2: 94.5299,
    y2: 113.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_29716_8725",
    x1: 7.37175,
    y1: 108.98,
    x2: 6.08365,
    y2: 111.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_29716_8725",
    x1: 69.1163,
    y1: 82.1621,
    x2: 69.4049,
    y2: 83.2928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_29716_8725",
    x1: 34.0047,
    y1: 132.633,
    x2: 32.6039,
    y2: 131.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_29716_8725",
    x1: 29.7429,
    y1: 60.9294,
    x2: 29.1111,
    y2: 60.1189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_29716_8725",
    x1: 62.0858,
    y1: 74.2323,
    x2: 62.8155,
    y2: 75.9594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_29716_8725",
    x1: 33.816,
    y1: 13.3624,
    x2: 37.2731,
    y2: 13.5281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_29716_8725",
    x1: 31.9596,
    y1: 36.8936,
    x2: 32.103,
    y2: 38.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_29716_8725",
    x1: 105.618,
    y1: -7.57166,
    x2: 103.93,
    y2: -8.30346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_29716_8725",
    x1: 94.4617,
    y1: 67.502,
    x2: 91.156,
    y2: 68.0661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_29716_8725",
    x1: 154.557,
    y1: 51.8647,
    x2: 151.795,
    y2: 51.4028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_29716_8725",
    x1: 77.7093,
    y1: 79.9096,
    x2: 78.6859,
    y2: 80.7215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_29716_8725",
    x1: 36.5156,
    y1: 51.5349,
    x2: 34.7415,
    y2: 56.2868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_29716_8725",
    x1: 65.1422,
    y1: 102.921,
    x2: 65.6128,
    y2: 103.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_29716_8725",
    x1: 105.809,
    y1: 82.0817,
    x2: 106.529,
    y2: 79.8151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_29716_8725",
    x1: 72.5731,
    y1: 81.768,
    x2: 75.6201,
    y2: 82.2562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_29716_8725",
    x1: 44.828,
    y1: 3.62812,
    x2: 47.8751,
    y2: 4.1163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_29716_8725",
    x1: 12.4643,
    y1: 86.6758,
    x2: 9.72258,
    y2: 88.9238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_29716_8725",
    x1: 123.647,
    y1: 53.9576,
    x2: 126.241,
    y2: 53.5798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_29716_8725",
    x1: 65.447,
    y1: 95.3955,
    x2: 63.7261,
    y2: 97.0464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_29716_8725",
    x1: -23.2108,
    y1: 56.583,
    x2: -24.7429,
    y2: 57.1938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_29716_8725",
    x1: 31.1297,
    y1: 61.252,
    x2: 29.563,
    y2: 59.3576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_29716_8725",
    x1: 124.841,
    y1: 73.4818,
    x2: 123.826,
    y2: 74.8357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_29716_8725",
    x1: 90.9802,
    y1: 93.4652,
    x2: 92.5952,
    y2: 91.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_29716_8725",
    x1: 72.1191,
    y1: 78.5717,
    x2: 73.2037,
    y2: 78.3915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_29716_8725",
    x1: 98.4894,
    y1: 15.826,
    x2: 100.912,
    y2: 15.4194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_29716_8725",
    x1: 67.2003,
    y1: 110.963,
    x2: 68.6593,
    y2: 111.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_29716_8725",
    x1: 55.6612,
    y1: 36.4528,
    x2: 53.6271,
    y2: 36.4624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_29716_8725",
    x1: 68.1553,
    y1: 100.585,
    x2: 69.1667,
    y2: 100.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_29716_8725",
    x1: 48.4799,
    y1: 45.8432,
    x2: 46.6346,
    y2: 45.7919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_29716_8725",
    x1: 112.252,
    y1: 31.8571,
    x2: 113.417,
    y2: 31.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_29716_8725",
    x1: 114.873,
    y1: 24.5414,
    x2: 114.737,
    y2: 28.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_29716_8725",
    x1: 125.833,
    y1: 86.086,
    x2: 125.039,
    y2: 86.3159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_29716_8725",
    x1: 110.543,
    y1: 46.4087,
    x2: 109.076,
    y2: 46.1728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_29716_8725",
    x1: 114.815,
    y1: 88.7936,
    x2: 114.365,
    y2: 89.8336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_29716_8725",
    x1: 111.452,
    y1: 46.8614,
    x2: 108.934,
    y2: 47.2119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_29716_8725",
    x1: 115.83,
    y1: 58.6143,
    x2: 114.286,
    y2: 59.5329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_29716_8725",
    x1: 64.7985,
    y1: 90.4181,
    x2: 62.5931,
    y2: 87.7841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_29716_8725",
    x1: 93.6635,
    y1: 79.7271,
    x2: 94.5961,
    y2: 78.7591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_29716_8725",
    x1: 114.459,
    y1: 94.1881,
    x2: 113.444,
    y2: 94.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_29716_8725",
    x1: 66.7026,
    y1: 56.7585,
    x2: 65.9776,
    y2: 59.6381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_29716_8725",
    x1: 78.7461,
    y1: 56.1053,
    x2: 77.7246,
    y2: 59.3847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_29716_8725",
    x1: 131.372,
    y1: 45.6795,
    x2: 128.749,
    y2: 46.1558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_29716_8725",
    x1: 70.5796,
    y1: 6.17011,
    x2: 69.6473,
    y2: 7.93669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_29716_8725",
    x1: 65.4132,
    y1: 113.807,
    x2: 61.3405,
    y2: 112.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_29716_8725",
    x1: 62.0273,
    y1: 97.2321,
    x2: 62.07,
    y2: 98.9511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_29716_8725",
    x1: 81.7892,
    y1: 61.063,
    x2: 82.7748,
    y2: 59.9939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_29716_8725",
    x1: 43.8506,
    y1: 128.074,
    x2: 42.5897,
    y2: 126.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_29716_8725",
    x1: 32.4356,
    y1: 81.8172,
    x2: 30.7757,
    y2: 80.4429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_29716_8725",
    x1: 69.0688,
    y1: 44.5235,
    x2: 66.2907,
    y2: 45.6157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_29716_8725",
    x1: 85.0553,
    y1: 22.4175,
    x2: 83.1405,
    y2: 23.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_29716_8725",
    x1: 97.5842,
    y1: 78.166,
    x2: 98.8834,
    y2: 77.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_29716_8725",
    x1: 48.9854,
    y1: 110.263,
    x2: 48.0817,
    y2: 112.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_29716_8725",
    x1: 137.342,
    y1: 23.1993,
    x2: 138.858,
    y2: 21.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_29716_8725",
    x1: 98.9171,
    y1: 53.5917,
    x2: 99.0648,
    y2: 54.9599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_29716_8725",
    x1: 127.156,
    y1: 97.1484,
    x2: 127.326,
    y2: 99.0951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_29716_8725",
    x1: 61.6763,
    y1: 64.3111,
    x2: 61.1714,
    y2: 65.7652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_29716_8725",
    x1: 55.9681,
    y1: 96.2113,
    x2: 54.056,
    y2: 100.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_29716_8725",
    x1: 80.7443,
    y1: 103.958,
    x2: 75.2901,
    y2: 122.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_29716_8725",
    x1: 61.2485,
    y1: 98.1333,
    x2: 56.2971,
    y2: 113.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_29716_8725",
    x1: 91.7974,
    y1: 113.347,
    x2: 89.0763,
    y2: 119.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_29716_8725",
    x1: 71.2168,
    y1: 103.268,
    x2: 67.6715,
    y2: 111.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_29716_8725",
    x1: 96.8359,
    y1: 34.3194,
    x2: 90.4126,
    y2: 37.1842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_29716_8725",
    x1: 95.6055,
    y1: 26.0365,
    x2: 81.0966,
    y2: 35.0697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_29716_8725",
    x1: 91.9933,
    y1: 22.6344,
    x2: 81.4568,
    y2: 28.5739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_29716_8725",
    x1: 92.7867,
    y1: 24.0462,
    x2: 82.2502,
    y2: 29.9857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_29716_8725",
    x1: 88.464,
    y1: 20.1925,
    x2: 82.0267,
    y2: 24.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_29716_8725",
    x1: 96.4971,
    y1: 27.4736,
    x2: 81.9914,
    y2: 36.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_29716_8725",
    x1: 91.1558,
    y1: 22.7704,
    x2: 85.0494,
    y2: 25.4939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_29716_8725",
    x1: 93.8854,
    y1: 27.3371,
    x2: 87.5658,
    y2: 30.1556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_29716_8725",
    x1: 24.4528,
    y1: 89.4882,
    x2: 22.3948,
    y2: 96.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_29716_8725",
    x1: 17.3672,
    y1: 84.9651,
    x2: 14.6208,
    y2: 101.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_29716_8725",
    x1: 12.4151,
    y1: 85.4388,
    x2: 9.96082,
    y2: 97.2231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_29716_8725",
    x1: 14.0045,
    y1: 85.7691,
    x2: 11.5502,
    y2: 97.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_29716_8725",
    x1: 8.24874,
    y1: 86.4712,
    x2: 7.04215,
    y2: 93.9425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_29716_8725",
    x1: 19.0437,
    y1: 85.2342,
    x2: 16.2954,
    y2: 102.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_29716_8725",
    x1: 11.961,
    y1: 86.1531,
    x2: 10.0044,
    y2: 92.5155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_29716_8725",
    x1: 17.2214,
    y1: 87.1069,
    x2: 15.1984,
    y2: 93.6854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_29716_8725",
    x1: 24.216,
    y1: 66.3751,
    x2: 23.5497,
    y2: 91.6592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_29716_8725",
    x1: 39.8328,
    y1: 74.8874,
    x2: 37.3997,
    y2: 83.0408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_29716_8725",
    x1: 77.2188,
    y1: 79.5653,
    x2: 69.6824,
    y2: 100.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_29716_8725",
    x1: 58.2177,
    y1: 72.2801,
    x2: 59.7535,
    y2: 110.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_29716_8725",
    x1: 59.5133,
    y1: 41.3804,
    x2: 55.2617,
    y2: 45.6575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_29716_8725",
    x1: 72.5142,
    y1: 53.8757,
    x2: 63.7697,
    y2: 59.8358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_29716_8725",
    x1: 66.7709,
    y1: 46.4136,
    x2: 53.2914,
    y2: 52.3532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_29716_8725",
    x1: 66.4563,
    y1: 51.7346,
    x2: 64.4414,
    y2: 53.7616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_29716_8725",
    x1: 74.6653,
    y1: 58.6463,
    x2: 70.0859,
    y2: 64.2163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_29716_8725",
    x1: 16.2855,
    y1: 40.4727,
    x2: 11.1121,
    y2: 50.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_29716_8725",
    x1: 53.0809,
    y1: 63.4082,
    x2: 49.2217,
    y2: 75.2735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_29716_8725",
    x1: 23.271,
    y1: 44.6881,
    x2: 18.0684,
    y2: 64.1332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_29716_8725",
    x1: 37.269,
    y1: 54.4426,
    x2: 32.581,
    y2: 74.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_29716_8725",
    x1: 46.047,
    y1: 61.2486,
    x2: 42.618,
    y2: 67.7803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_29716_8725",
    x1: 31.1296,
    y1: 52.9288,
    x2: 27.4831,
    y2: 59.8748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_29716_8725",
    x1: 88.8793,
    y1: 54.947,
    x2: 84.2725,
    y2: 57.9785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_29716_8725",
    x1: 103.224,
    y1: 85.6015,
    x2: 101.46,
    y2: 86.7621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_29716_8725",
    x1: 105.08,
    y1: 77.3682,
    x2: 90.934,
    y2: 87.7582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_29716_8725",
    x1: 97.3844,
    y1: 71.0893,
    x2: 92.1931,
    y2: 74.5055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_29716_8725",
    x1: 94.3117,
    y1: 62.3108,
    x2: 78.5872,
    y2: 72.4465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_29716_8725",
    x1: 19.4094,
    y1: 112.745,
    x2: 19.088,
    y2: 119.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_29716_8725",
    x1: 60.0283,
    y1: 120.611,
    x2: 59.9059,
    y2: 123.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_29716_8725",
    x1: 53.2036,
    y1: 112.908,
    x2: 53.2613,
    y2: 134.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_29716_8725",
    x1: 41.4749,
    y1: 115.958,
    x2: 41.1134,
    y2: 123.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_29716_8725",
    x1: 30.5907,
    y1: 112.693,
    x2: 29.2841,
    y2: 135.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_29716_8725",
    x1: 120.053,
    y1: 25.6081,
    x2: 112.069,
    y2: 26.3475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_29716_8725",
    x1: 127.767,
    y1: 64.8025,
    x2: 115.106,
    y2: 61.8188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_29716_8725",
    x1: 121.841,
    y1: 19.5745,
    x2: 102.516,
    y2: 18.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_29716_8725",
    x1: 126.43,
    y1: 52.0578,
    x2: 107.242,
    y2: 45.8578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_29716_8725",
    x1: 123.828,
    y1: 57.6775,
    x2: 120.552,
    y2: 57.9809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_29716_8725",
    x1: 123.944,
    y1: 41.789,
    x2: 116.036,
    y2: 42.5215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_29716_8725",
    x1: 125.929,
    y1: 36.402,
    x2: 101.512,
    y2: 27.7575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightConfetti);
export default __webpack_public_path__ + "static/media/right-confetti.7b239a7b287d89bc6df0fbafb313cdb6.svg";
export { ForwardRef as ReactComponent };